<template>
  <div>
    <div v-if="loading">
      <v-skeleton-loader
          type="heading, list-item-avatar-two-line@3"
      >
      </v-skeleton-loader>
    </div>
    <div v-else-if="pickupPoints">
      <v-text-field
          v-model="query"
          clearable
          persistent-hint
          label="Введите название или адрес точки для поиска..."
          :hide-details="!selectedTs"
          :hint="searchHint"
          @click:clear="queryClear"
          @input="queryChange"
      ></v-text-field>

      <v-radio-group
          v-if="filteredPoints.length"
          class="selector"
          :disabled="disabled"
          :value="selectedValue"
      >
        <v-radio
            v-for="item in filteredPoints"
            :key="item.id"
            :value="item.id"
            @click="$emit('select', item)"
        >
          <template slot="label">
            <v-list-item
                class="pl-0"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{getItemTitle(item)}}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <b>Адрес:</b> {{item.address}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-radio>
      </v-radio-group>

      <v-list-item v-if="!filteredPoints.length">
        <v-list-item-avatar>
          <v-icon>mdi-information-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            Точки выдачи не найдены
          </v-list-item-title>
          <v-list-item-subtitle>
            Попробуйте изменить условия поиска
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import {getPickupPointTitle} from '@/services/utils'

export default {
  name: 'PickupPointSelector',
  computed: {
    searchHint () {
      const who = this.settedByAdmin ? 'организатором' : 'вами'
      return this.selectedTs ?
          `Точка выдачи была выбрана ${who} ${this.$root.$options.filters['localizedDate'](this.selectedTs)}` : ''
    }
  },
  data () {
    return {
      filteredPoints: [],
      selectedValue: null,
      query: ''
    }
  },
  methods: {
    getItemTitle (item) {
      return getPickupPointTitle(item)
    },
    queryChange ($event) {
      if ($event && this.pickupPoints) {
        this.filteredPoints = this._pullUpSelected(this.pickupPoints.filter(item =>
          this.query.toLowerCase().split(' ').every(
            v => this.getItemTitle(item).toLowerCase().includes(v) || item.address.toLowerCase().includes(v)
          )
        ))
      } else {
        this.filteredPoints = this._pullUpSelected(this.pickupPoints)
      }
    },
    queryClear () {
      this.query = ''
    },
    _pullUpSelected (arr) {
      const copy = arr.slice()
      if (this.selectedId) {
        const idx = copy.findIndex(elm => elm.id === this.selectedId)
        this.selectedValue = null
        if (idx > -1) {
          const deleted = copy.splice(idx, 1)
          copy.unshift(deleted[0])
          this.selectedValue = deleted[0].id
        }
      }
      return copy
    }
  },
  props: {
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    pickupPoints: {
      type: Array
    },
    selectedId: {
      type: String
    },
    selectedTs: {
      type: Number
    },
    settedByAdmin: {
      type: Boolean
    }
  },
  watch: {
    'pickupPoints' (val) {
      if (!val) {
        return
      }
      this.filteredPoints = this._pullUpSelected(val)
    }
  }
}
</script>

<style scoped>
</style>